import {SwaggerRepository} from "@/apps/registration-send-to-crm-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}